import { PropertyValue } from '../../composition-functions'
import { PropertyEnumWithDescription } from '../../../contracts/Page'

/** нормализация данных из массива в объект для СТРОКОВЫХ значения */
export const propertyValuesNormalizer = (
  arr: Array<PropertyValue | PropertyEnumWithDescription>
): Record<string, string> => {
  const obj: any = {}
  arr &&
    arr.forEach((property) => {
      const { property: _property, id, value, description } = property || {}
      const code = _property?.code
      if (code) {
        if (!obj[code]) {
          obj[code] = value
          if (description) {
            obj[`${code}Description`] = description
          }
        } else if (Array.isArray(obj[code])) {
          obj[code].push(value)
          if (description) {
            obj[`${code}Description`].push(description)
          }
        } else {
          obj[code] = [value, obj[code]]
          if (description) {
            obj[`${code}Description`] = [obj[`${code}Description`], description]
          }
        }
        obj[`id-${code}`] = id
      }
    })
  return obj
}
